module.exports = __webpack_public_path__ + "static/media/wall-5.9b313a39.jpg";